/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { metricsGetApiV3MetricsTotalAwaitingNodesCount } from "../../funcs/metricsGetApiV3MetricsTotalAwaitingNodesCount.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .GetApiV3MetricsTotalAwaitingNodesCountRequest$inboundSchema.optional(),
};

export const tool$metricsGetApiV3MetricsTotalAwaitingNodesCount: ToolDefinition<
  typeof args
> = {
  name: "metrics-get-api-v3-metrics-total-awaiting-nodes-count",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] =
      await metricsGetApiV3MetricsTotalAwaitingNodesCount(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
